var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewClock = function SvgNewClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.003 3.05C8.855 3.05 3.053 8.852 3.053 16s5.802 12.95 12.95 12.95 12.95-5.802 12.95-12.95-5.802-12.95-12.95-12.95ZM.953 16C.953 7.692 7.695.95 16.003.95S31.053 7.692 31.053 16s-6.742 15.05-15.05 15.05S.953 24.308.953 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.488 8.664c.58 0 1.05.47 1.05 1.05v5.74c0 .215.082.526.264.846.183.32.409.55.593.659l.003.001 4.34 2.59a1.05 1.05 0 0 1-1.077 1.804l-4.337-2.589h-.001c-.572-.34-1.03-.873-1.345-1.424-.315-.552-.54-1.22-.54-1.887v-5.74c0-.58.47-1.05 1.05-1.05Z"
  }))));
};
export default SvgNewClock;